import { TLoadable, createUnloaded, createLoading, createLoadErrored, createLoaded } from "../../../../sg-core";
import { IContextAction } from "../actions/contextActions";
import { IRole } from "../../interfaces/IHavainnotUser";
import { itemsToMappedIdList } from "../../utils/item.helpers";
import { IAppParatemers } from "../../interfaces/AppParatemers";
import { IAppConfigurations } from "../../interfaces/IAppConfigurations";

export const defaultContextState: IContextState = {
    initialContextLoaded: createUnloaded(),
    appRoles: {},
    appRoleList: createUnloaded(),
    appConfigs: createUnloaded()
};

export interface IContextState {
    initialContextLoaded: TLoadable<boolean>;
    appRoles: { [key: string]: IRole };
    appRoleList: TLoadable<number[]>;
    appConfigs: TLoadable<IAppConfigurations | null>;
};

export default function ContextReducer(state = defaultContextState, action: IContextAction) {
    switch (action.type) {

        case "REQUEST_FETCH_INITIAL_HAVAINNOT20_CONTEXT": {
            return {
                ...state,
                initialContextLoaded: createLoading(),
                appConfigs: createLoading(),
            };
        }

        case "SUCCESS_FETCH_INITIAL_HAVAINNOT20_CONTEXT": {
            return {
                ...state,
                initialContextLoaded: createLoaded(true),
                appConfigs: createLoaded(action.payload.appConfigs)

            };
        }

        case "FAILURE_FETCH_INITIAL_HAVAINNOT20_CONTEXT": {
            return {
                ...state,
                initialContextLoaded: createLoadErrored(action.payload.error),
                appConfigs: createLoadErrored(action.payload.error)
            };
        }

        case "UPDATE_HAVAINNOT20_CONTEXT": {
            return {
                ...state,
                initialContextLoaded: createLoaded(true),
            };
        }


        case "SUCCESS_APP_ROLES": {
            const parsedRoles = itemsToMappedIdList(action.payload.roles);
            return {
                ...state,
                appRoles: parsedRoles.mapping,
                appRoleList: createLoaded(parsedRoles.ids)
            };
        }

        default: {
            return state;
        }
    }
}
